import React from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../../providers/AuthProvider";

export function RequireNonSuperAdmin() {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  if (isLoading) return null;

  if (user?.role === "super_admin") {
    // Allow super_admin to access read-only catalog management.
    if (location.pathname.startsWith("/settings/categories")) return <Outlet />;
    if (location.pathname.startsWith("/settings/brands")) return <Outlet />;
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}

